// customAnchorPlugin.js
import * as util from '@/utils/util.js';

export default (editor, values) => {
  // 注册一个自定义按钮
  editor.ui.registry.addButton('customAnchor', {
    text: '锚点',
    icon: 'bookmark', // 使用 TinyMCE 内置图标
    onAction: () => {
      // 打开自定义对话框
      editor.windowManager.open({
        title: '插入锚点',
        body: {
          type: 'panel',
          items: [
      //       {
      //         type: 'input',
      //         name: 'anchorID',
      //         label: '锚点ID',
      //         placeholder: '例如: intro'
      //       },
						// {
						//   type: 'input',
						//   name: 'anchorName',
						//   label: '锚点名称',
						//   placeholder: '例如: 锚点名称'
						// },
						{ 
							type: 'selectbox', 
							name: 'anchorID', 
							label: '锚点名称', 
							items: values
							// items: [
							// 	{ text: '默认蓝点', value: 'default' },
							// 	{ text: '红色标记', value: 'red-mark' },
							// 	{ text: '隐藏占位', value: 'hidden' }
							// ] 
						}
          ]
        },
        buttons: [
          {
            type: 'cancel',
            text: '取消'
          },
          {
            type: 'submit',
            text: '插入',
            primary: true
          }
        ],
        onSubmit: (api) => {
          const data = api.getData();
					//console.log(editor.getContent());
					
          const anchorID = data.anchorID;
          
          if (anchorID) {
						let content=editor.getContent();
						
						let findItem=values.find(item=>item.value==anchorID);
						
						let anchorName=findItem.text;
						
						let findDom=content.indexOf('id="' + anchorID + '"');
						
						if(findDom>=0){
							util.Alert(anchorName + '已存在！');
							return;
						}
						
            // 插入带有特定类名或属性的锚点 HTML
            // 这里我们插入一个带 id 的空 span 或 a 标签
            editor.insertContent(`<a id="${anchorID}" title="${anchorName}" class="mce-item-anchor"></a>`);
            
            // 可选：立即创建一个指向该锚点的链接用于测试
            // editor.insertContent(`<a href="#${anchorName}">跳转到 ${anchorName}</a>`);
          }
          api.close();
        }
      });
    }
  });

  // 注册菜单项（可选）
  editor.ui.registry.addMenuItem('customAnchorMenu', {
    text: '锚点',
    icon: 'bookmark',
    onAction: () => {
      editor.execCommand('mceCustomAnchor'); // 触发命令
    }
  });
  
  // 注册命令
  editor.addCommand('mceCustomAnchor', () => {
     // 可以复用上面的逻辑，或者直接调用 windowManager.open
     // 为了简化，通常直接在 button 的 onAction 中处理
  });
};
